module.exports = __webpack_public_path__ + "img/template.c83704c7.svg";